import { Box, CircularProgress } from "@mui/material";
import { FC, ReactNode } from "react";

interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
  loaded?: boolean;
}
const LoadingProgress = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "50vh",
    }}
  >
    <CircularProgress />
  </Box>
);

const TabPanel: FC<TabPanelProps> = ({
  children,
  loaded = true,
  value,
  index,
  ...other
}) => {
  return !loaded ? (
    <LoadingProgress />
  ) : (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
};

export default TabPanel;
